import React from 'react';
import { ChildContainer } from './GeotabGridComponents';
import { Card } from './Cards/Card';
import { cardTypes } from '../helpers/ObjectTypeModels/Card';
import { getLanguageRouteAndPrefixByCodeAndRouteKey } from '@helpers/languages';
import { useAtom } from 'jotai';
import { selectedLanguageAtom } from '@atoms/appSettings';
import { ArticleEntity } from '@models/article';
import { Grid } from '@mui/material';

interface BottomArticleCardListProps {
    articleList: ArticleEntity[];
    routeType: 'blogPostUrl' | 'pressReleaseUrl' | 'whitePaperUrl' | 'caseStudyUrl' | 'glossaryUrl';
}
export function BottomArticleCardList({ articleList, routeType }: BottomArticleCardListProps): React.ReactElement {
    const [selectedLanguage] = useAtom(selectedLanguageAtom);

    return (
        <ChildContainer breakSpaceValue={2}>
            {articleList.map((articleCard, index) => {
                const cardContent = {
                    title: articleCard.title,
                    body: articleCard.description,
                    image: {
                        imagePath: articleCard.cardImageUrl,
                        mobilePath: articleCard.mobileCardImageUrl,
                        imageAlt: articleCard.cardImageAlt,
                        lazyLoad: true,
                    },
                    publishedDateUtc: articleCard.publishedDateUtc,
                };

                return (
                    <Grid item xs={12} md={6} lg={3} key={articleCard.slug}>
                        <Card
                            card={{
                                ...cardTypes.BLOG_FOUR_COLUMN,
                                content: cardContent,
                            }}
                            href={`${getLanguageRouteAndPrefixByCodeAndRouteKey(selectedLanguage, routeType)}${
                                articleCard.slug
                            }`}
                            data-testid={`${routeType}Card${index}`}
                        />
                    </Grid>
                );
            })}
        </ChildContainer>
    );
}
